<template>
    <BreadCrumb PageTitle="Point des paiements des usagers" />
    <ListePaiementUsager />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListePaiementUsager from '../../components/Paiement/ListePaiementUsager.vue';
    export default defineComponent({
      name: "ListePaiementUsagerPage",
      components: {
        BreadCrumb,
        ListePaiementUsager,
      },
    });
  </script>